import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * Creates 4x4 plane gameobjects.
 * @param {HYPERCUBEJS.Material} [$material] The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectplane4x4($material = HYPERCUBEJS.DEFAULTS.material()) {

    const plane4x4 = new HYPERCUBEJS.Node('plane4x4');
    const meshplane4x4 = new HYPERCUBEJS.MeshPlane('meshplane4x4', [4, 4]);

    meshplane4x4.setmaterial($material);
    plane4x4.addmesh(meshplane4x4);

    plane4x4.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-2, 0, -2],
        'max': [2, 0, 2]
    });

    return plane4x4;
}

export {

    gameobjectplane4x4
};

export default gameobjectplane4x4;
